module.exports = __webpack_public_path__ + "media/images/ui__textArrowUp-6c49c474d9dbb06ff14537807d0321fb.png";